export default {
	name	: 'BaseModal',
	props	: {
		isVisible	: Boolean,
		title		: String,
		maxWidth	: {
			type		: String,
			default		: '600px'
		},
		canClose	: {
			type		: Boolean,
			default		: true
		}
	},
	methods	: {
		handleClose() {
			if (this.canClose) {
				this.$emit('close')
			}
		}
	},
	watch	: {
		isVisible(val) {
			// Блокування прокрутки body при відкритті
			if (val) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = ''
			}
		}
	},
	beforeDestroy() {
		// Відновлення прокрутки при знищенні компонента
		document.body.style.overflow = ''
	}
}
